var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "50px",
    viewBox: "0 0 150 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v2-artboard-5-copy-8",
    transform: "translate(-132.000000, -125.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(132.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4186657,24.5103714 C14.4186657,14.0942237 20.0617958,11.6635092 23.7298704,11.6635092 C27.3963449,11.6635092 33.0354745,14.0942237 33.0354745,24.5103714 C33.0354745,34.9361204 27.3963449,37.3612342 23.7298704,37.3612342 C20.0617958,37.3612342 14.4186657,34.9361204 14.4186657,24.5103714 M0,24.5103714 C0,38.8070213 9.50723015,49.029544 23.7298704,49.029544 C37.9509105,49.029544 47.4585407,38.8070213 47.4585407,24.5103714 C47.4585407,10.2261232 37.9509105,0 23.7298704,0 C9.50723015,0 0,10.2261232 0,24.5103714",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "59.7803635 12.8344862 46.6666667 12.8344862 46.6666667 0.833333333 87.3039248 0.833333333 87.3039248 12.8344862 74.1938284 12.8344862 74.1938284 47.6389896 59.7803635 47.6389896"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "90.8333333 47.6353891 105.255599 47.6353891 105.255599 0.833333333 90.8333333 0.833333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.922266,32.1829642 C121.922266,33.3663173 122.120292,34.4156531 122.447134,35.2593623 C123.49767,38.085728 126.643277,38.6726039 129.329625,38.6726039 C131.68913,38.6726039 135.297997,37.8897026 135.297997,34.4156531 C135.297997,31.9909394 133.262934,31.331654 125.19829,29.0413577 C117.796932,26.9390857 109.333037,24.9120234 109.333037,15.4700017 C109.333037,4.65580242 118.579434,0 128.217081,0 C138.375595,0 147.354757,3.8681005 147.752408,15.2739763 L134.113844,15.2739763 C134.373477,13.5025471 133.591376,12.3319957 132.406023,11.538693 C131.233471,10.6873829 129.594859,10.3589404 128.149872,10.3589404 C126.184018,10.3589404 122.969602,10.8778075 122.969602,13.5025471 C123.236436,16.8441795 129.923301,17.5662729 136.540958,19.4033106 C143.158614,21.2363478 149.714662,24.3219471 149.714662,32.9054577 C149.714662,45.0982353 138.502811,49.0255435 128.082663,49.0255435 C122.775577,49.0255435 107.638018,47.1252976 107.5,32.1829642 L121.922266,32.1829642 Z",
    id: "Fill-5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1b334c3450b2679adab118c6750c9e8d.svg";
export { ForwardRef as ReactComponent };